// extracted by mini-css-extract-plugin
export default {"number_counter":"NumberCounter_number_counter__srPmV","current_wrapper":"NumberCounter_current_wrapper__FkT7T","total_wrapper":"NumberCounter_total_wrapper__8VtTC"};